module.exports = __webpack_public_path__ + "static/media/office4.28e4952f.jpg";